import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

export const useAddAppMetafieldsToShop = () => {
  const { addToast } = useToast();
  return async () => {
    const response = await typedFrontendVendorApi.postReq("/extensions/update-shop");

    if (response.type !== "success") {
      addToast("There was an error adding the app metafield");
    }
  };
};
